import React, { Component } from 'react'
import { getGroupName } from '@disco/utils/groups'
import ClipboardInput from 'components/common/clipboard-input'
import Button from 'components/ui/button'
import type { Group } from 'types/group'
type User = {
  csrfToken: string
}
type Props = {
  url: string
  user: User
  group?: Group
  sendMixpanelEvent: (...args: Array<any>) => any
}
type State = {
  copyInboxModalOpen: boolean
}
export default class CopyInboxUrl extends Component<Props, State> {
  state: State = {
    copyInboxModalOpen: false,
  }
  _toggleModalOpen: () => void = () => {
    // Event #4 from https://disco-team.atlassian.net/browse/DISCO-4710
    if (this.props.group && !this.state.copyInboxModalOpen) {
      this.props.sendMixpanelEvent('Click icon', {
        type: this.props.group.group_type,
        name: this.props.group.name,
        icon: 'copy_link',
        context: 'Inbox',
      })
    }

    this.setState({
      copyInboxModalOpen: !this.state.copyInboxModalOpen,
    })
  }
  _onInboxUrlCopy: () => void = () => {
    this.props.sendMixpanelEvent('Copy inbox url', {
      Url: this.props.url,
    })
  }

  render(): React.ReactNode {
    const groupName = getGroupName(this.props.group)
    return (
      <React.Fragment>
        <ClipboardInput
          key={this.props.group?.id}
          successNotification={{
            title: `${groupName} link copied!`,
            message: 'The link has been copied to your clipboard.',
            level: 'success',
          }}
          customCta={
            <Button
              appearance="icon"
              icon="link"
              tooltip="Copy Inbox URL"
              onClick={() => this._onInboxUrlCopy()}
            />
          }
          value={this.props.url}
        />
      </React.Fragment>
    )
  }
}
